import React, { useEffect, useState } from 'react'
import Main from '../../cpn/Main'
import { Space, Table } from 'antd';
import { useQiyeTypeListQuery } from '../../store/dianshangtaizhangApi';
import FirmTypeEdit from './FirmTypeEdit';
import TradeSelect from '../trade/TradeSelect';
function FirmTypeQuery() {
    const [list, setList] = useState();    
    const [query,setQuery] = useState({qyt_hyt_id:''});
    const {data, isSuccess} = useQiyeTypeListQuery(query, {refetchOnMountOrArgChange: true})
    useEffect(() => {
        if (isSuccess) {
            console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {qyt_id:key,qyt_hyt_id,qyt_hyt_name,qyt_name,} = item;                 
                    return item = {key,qyt_hyt_id,qyt_hyt_name,qyt_name,}
                }) 
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.qyt_ctime;
                    let bTimeString = b.qyt_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'qyt_hyt_name',
            title: '行业',            
            dataIndex: 'qyt_hyt_name',
        },
        {
            key: 'qyt_name',
            title: '企业类型',            
            dataIndex: 'qyt_name',
        },
        {
            key: 'key',
            title: '编号',            
            dataIndex: 'key',
        },    
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>
                        <FirmTypeEdit qyt_id={record.key} qyt_name={record.qyt_name}/>
                    </Space>
                </>
            }
        },
    ]   
    return (
        <Main selectedKeys={['/FirmTypeQuery']}>
            <div>
                <TradeSelect 
                    label='行业'      
                    onChange={(e) => {
                        setQuery({qyt_hyt_id:e})
                    }}
                    style={{width:'200px'}}

                />
            </div>
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{
                    showSizeChanger:true,
                    defaultPageSize:'50',
                    showTotal:(total) => `共${total}条`,
                }} 
            />
        </Main>
    )
}

export default FirmTypeQuery